'use strict'

/**
 * Module Cross-Sell
 */

const SESSION_STORAGE_KEY = 'MDZCS'

/**
 * Enregistrement dans le session storage des articles de cross sell
 */
function saveCrossSellArticles() {
    try {
        const articles = $('.cross-sell .card-product')

        if (!articles.length) {
            return
        }

        let data = []

        articles.each(function () {
            const value = $(this).data('crossSell')

            if (!value) {
                return
            }

            const [reference, intention] = value.split('|')

            data.push({ reference, intention: parseInt(intention) })
        })

        sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(data))
    } catch {
        sessionStorage.setItem(SESSION_STORAGE_KEY, '[]')
    }
}

/**
 * Récupération de l'intention à partir de le référence prodel
 */
function getIntentionByReference(refModele, codeCouleur) {
    try {
        if (!refModele || !codeCouleur) {
            return 0
        }

        const reference = `${refModele}-${codeCouleur}`

        const articles = getCrossSellArticles()

        const article = articles.find((x) => x.reference === reference)

        if (!article) {
            return 0
        }

        return article.intention
    } catch {
        return 0
    }
}

/**
 * Récupération des articles du cross sell
 */
function getCrossSellArticles() {
    try {
        const articles = sessionStorage.getItem(SESSION_STORAGE_KEY)

        if (!articles) {
            return []
        }

        return JSON.parse(articles)
    } catch {
        return []
    }
}

export default {
    saveCrossSellArticles: saveCrossSellArticles,
    getIntentionByReference: getIntentionByReference
}
